import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[viewMode]',
    standalone: false
})
export class ViewModeDirective {

  constructor(public tpl: TemplateRef<any>) {
  }

}
